import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Spinner, Form } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { usePageTitle } from "../../../../layouts/PageHeaderExtra";
import { useStatoNelTitolo } from "../../../../components/Util/StatoProdotto";
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { bookingSubscriptionExpirationType } from "../../../../components/Util/enum";
import { useFederations } from "../../../../../hooks/useFederations";
import { VAT_OPTIONS, findVatOption } from '../../../../components/Util/vatOptions';
import { sportDelProdotto, nomiSport, organismiComuni, opzioniOrganismi } from '../../../../components/Util/sportProdotto';

export const AdminSubscriptionsEdit = () => {
    const { id } = useParams();

    const { federations } = useFederations();

	const [loadingShowed, setLoadingShowed] = useState(false);

    // Sport (con organismi configurati) della struttura proprietaria dell'abbonamento
    const [clubSports, setClubSports] = useState([]);

    const optionsBoolean = [
        { value: true, label: "Si" },
        { value: false, label: "No" }
    ]




	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [bookingSubscriptions] = await Promise.all([
                        apiClient.getBookingSubscriptionById(token, id)
                    ]);
					setLoadingShowed(false);
                    
                    if(bookingSubscriptions) {
                        // Carica il profilo del club proprietario per conoscere gli organismi
                        // configurati per ogni sport (sportPromotionBody)
                        if (bookingSubscriptions.clubId) {
                            const clubProfile = await apiClient.getProfiles(token, bookingSubscriptions.clubId);
                            if (clubProfile && !clubProfile.error && clubProfile.club && clubProfile.club.sports) {
                                setClubSports(clubProfile.club.sports);
                            }
                        }
                        const elementFormData = {
                            id: bookingSubscriptions.id,
                            name: bookingSubscriptions.name,
                            sportTypes: sportDelProdotto(bookingSubscriptions),
                            expiration_type: bookingSubscriptions.expiration_type,
                            standard_price: bookingSubscriptions.standard_price,
                            vat_rate: bookingSubscriptions.vat_rate,
                            vat_nature: bookingSubscriptions.vat_nature,
                            iva_5_percent: bookingSubscriptions.iva_5_percent,
                            member_price: bookingSubscriptions.member_price,
                            federated_price: bookingSubscriptions.federated_price,
                            fitcoin_percentage: bookingSubscriptions.fitcoin_percentage,
                            payable_in_club: bookingSubscriptions.payable_in_club,
                            payable_stripe: bookingSubscriptions.payable_stripe,
                            payable_bank: bookingSubscriptions.payable_bank,
                            auto_renew: bookingSubscriptions.auto_renew,
                            grants_club_membership: bookingSubscriptions.grants_club_membership,
                            grants_federated_status: bookingSubscriptions.grants_federated_status,
                            federation_code: bookingSubscriptions.federation_code || '',
                            status: bookingSubscriptions.status,
                            description: bookingSubscriptions.description,
                            clubName: bookingSubscriptions.clubName,
                            subscriptionPicture: bookingSubscriptions.subscriptionPicture
                        }
                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

    const [formData, setFormData] = useState({
        id: '',
        name: '', 
        sportTypes: [],
        expiration_type: '',
        standard_price: 0,
        member_price: 0,
        federated_price: 0,
        fitcoin_percentage: 0,
        payable_in_club: false,
        payable_stripe: false,
        payable_bank: false,
        auto_renew: false,
        grants_club_membership: false,
        grants_federated_status: false,
        federation_code: '',
        status: '',
        subscriptionPicture: ''
    });

    // Titolo della pagina = nome dell'abbonamento, appena caricato.
    usePageTitle(formData?.name);

    // Stato nella tendina accanto al titolo: si salva subito (regola SUI). Il super admin lo cambia per
    // qualsiasi struttura; una bozza resta «Bozza» (si attiva dalla scheda della struttura).
    const cambiaStato = async (attiva) => {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (!tokenDetailsString) return { annullato: true };
        const token = JSON.parse(tokenDetailsString).idToken;
        const apiClient = new MyApiClient();
        const nuovo = attiva ? 'PURCHASABLE' : 'CANCELLED';
        const result = await apiClient.changeSubscriptionStatus(token, id, nuovo);
        if (result && result.error) return { error: result.error };
        setFormData(prev => ({ ...prev, status: nuovo }));
        return {};
    };
    useStatoNelTitolo({
        visibile: !!formData?.status,
        attivo: formData?.status === 'PURCHASABLE',
        bozza: formData?.status === 'DRAFT',
        onCambia: cambiaStato,
    });



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    const handleSelectChangeBoolean = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || false;
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    // Gli organismi sono quelli che la struttura ha indicato per TUTTI gli sport del prodotto
    const getAvailableFederations = () => opzioniOrganismi(federations, organismiComuni(formData.sportTypes, clubSports));

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

            <Row className="align-items-start mt-4">
                <div className="col-xl-9">
                    <Card>
                        <Card.Header><h4 className="card-title">Informazioni generali Abbonamento</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6">
                                    <Form.Label>Struttura</Form.Label>
                                    <Form.Control disabled={formData.status!=='DRAFT'} 
                                        className="mt-2"
                                        style={formData.status!=='DRAFT' ? {color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" } : {color: '#000000'}}
                                        placeholder='Inserisci Nome' type="text" name="name" value={formData.clubName} onChange={handleChange} />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6">
                                    <Form.Label>Nome abbonamento</Form.Label>
                                    <Form.Control disabled
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal", fontSize: "14px" }}
                                        placeholder='Inserisci Nome' type="text" name="name" value={formData.name} onChange={handleChange} />
                                </Col>
                                <Col className="col-xl-6">
                                    <Form.Label>Sport</Form.Label>
                                    <div className="sid-readonly-value sid-readonly-value--campo mt-2">{nomiSport(formData) || '—'}</div>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6">
                                    <Form.Label>Durata</Form.Label>
                                    <Select
                                        isDisabled
                                        name="expiration_type" 
                                        value={bookingSubscriptionExpirationType.find(option => option.value === formData.expiration_type)}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "expiration_type")}
                                        options={bookingSubscriptionExpirationType}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }}
                                    />
                                </Col>
                                <Col className="col-xl-6 text-center">
                                    <h4 className="text-center mb-0">Immagine del prodotto</h4>
                                    <br></br>
                                    {formData.subscriptionPicture ? 
                                        <img src={formData.subscriptionPicture} style={{maxHeight: '200px', maxWidth: '100%'}} alt="" /> 
                                    : 
                                        'Nessuna immagine caricata'
                                    }
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-12">
                                    <Form.Label>Descrizione</Form.Label>
                                    <Form.Control 
                                        disabled
                                        rows={10} 
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        as="textarea" 
                                        name="description" 
                                        value={formData.description} 
                                        onChange={handleChange} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Prezzi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6">
                                    <Form.Label>Prezzo standard</Form.Label>
                                    <Form.Control disabled 
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        className="mt-2"
                                        placeholder='Inserisci il prezzo standard' type="text" name="standard_price" value={formData.standard_price+' €'} onChange={handleChange} />
                                </Col>
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>IVA</Form.Label>
                                    <Select
                                        isDisabled
                                        className="mt-2"
                                        value={findVatOption(formData)}
                                        options={VAT_OPTIONS}
                                    />
                                </Col>
                                <Col className="col-xl-6">
                                    <Form.Label>Prezzo riservato ai tesserati / soci</Form.Label>
                                    <Form.Control disabled 
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        className="mt-2" 
                                        placeholder='Inserisci il prezzo riservato ai tesserati / soci' type="text" name="federated_price" value={formData.federated_price+' €'} onChange={handleChange} />
                                </Col>
                                <Col className="col-xl-6">
                                    <Form.Label>Cashback in fitcoin</Form.Label>
                                    <Form.Control 
                                        disabled
                                        className="mt-2"
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        placeholder='Inserisci il numero di fitcoin in cashback' 
                                        type="text" 
                                        name="fitcoin_percentage" 
                                        value={formData.fitcoin_percentage} 
                                        onChange={handleChange} />
                                </Col>
                            </Row>
                            {/*<Row className="mt-4">
                                <Col className="col-xl-6">
                                    <Form.Label>Prezzo riservato ai soci</Form.Label>
                                    <Form.Control disabled 
                                        style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }} 
                                        className="mt-2" 
                                        placeholder='Inserisci il prezzo riservato ai soci' type="text" name="member_price" value={formData.member_price+' €'} onChange={handleChange} />
                                </Col>
                            </Row>*/}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Privilegi</h4></Card.Header>
                        <Card.Body>
                            <Row>
                                <Col className="col-xl-6">
                                    <Form.Label>Rende tesserato negli sport del prodotto</Form.Label>
                                    <Select
                                        isDisabled
                                        name="grants_federated_status" 
                                        value={optionsBoolean.find(option => option.value === formData.grants_federated_status)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "grants_federated_status")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }}
                                    />
                                </Col>
                                {formData.grants_federated_status && 
                                <Col className="col-xl-6">
                                    <Form.Label>Organismo</Form.Label>
                                    <Select
                                        isDisabled
                                        name="federation_code" 
                                        value={opzioniOrganismi(federations, [formData.federation_code])[0] || null}
                                        onChange={(selectedOption) => handleSelectChange(selectedOption, "federation_code")}
                                        options={getAvailableFederations()}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }}
                                    />
                                </Col>
                                }
                                <Col className="col-xl-6 mt-3">
                                    <Form.Label>Rende socio della struttura</Form.Label>
                                    <Select
                                        isDisabled
                                        name="grants_club_membership" 
                                        value={optionsBoolean.find(option => option.value === formData.grants_club_membership)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "grants_club_membership")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }}
                                    />
                                    <small className="text-muted d-block mt-2">
                                        Chi acquista entra nel libro soci della struttura quando l'ordine risulta pagato.
                                        <br />
                                        <strong>Questi abbonamenti non compaiono nel catalogo dell'app:</strong>
                                        {' '}si vendono dal Manager, in vendita manuale.
                                    </small>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header><h4 className="card-title">Condizioni aggiuntive</h4></Card.Header>
                        <Card.Body>
                            <Row className="mt-4">
                                <Col className="col-xl-6 mb-3">
                                    <Form.Label>Acquisto pagabile in struttura</Form.Label>
                                    <Select
                                        isDisabled
                                        name="payable_in_club" 
                                        value={optionsBoolean.find(option => option.value === formData.payable_in_club)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_in_club")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }
                                        }
                                    />
                                </Col>
                                <Col className="col-xl-6 mb-3">
                                    <Form.Label>Acquisto pagabile su Stripe</Form.Label>
                                    <Select
                                        isDisabled
                                        name="payable_stripe" 
                                        value={optionsBoolean.find(option => option.value === formData.payable_stripe)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_stripe")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }
                                        }
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col className="col-xl-6 mb-3">
                                    <Form.Label>Acquisto pagabile con bonifico</Form.Label>
                                    <Select
                                        isDisabled
                                        name="payable_bank" 
                                        value={optionsBoolean.find(option => option.value === formData.payable_bank)}
                                        onChange={(selectedOption) => handleSelectChangeBoolean(selectedOption, "payable_bank")}
                                        options={optionsBoolean}
                                        style={{
                                            lineHeight: "40px",
                                            color: "#fd7e14",
                                            paddingLeft: " 15px",
                                        }
                                        }
                                    />
                                </Col>
                            </Row>
                            
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-xl-3">
                    
                </div>
            </Row>
		</>
	)

}
export default AdminSubscriptionsEdit;